module.exports = __webpack_public_path__ + "img/complete-bilingual-solution.0ee37a9d.webp";